import React, { useEffect } from 'react'
import './zodiac.css'
import EasySpeech from 'easy-speech'
import aries from '../../assets/aries.png'
import taurus from '../../assets/taurus.png'
import gemini from '../../assets/gemini.png'
import cancer from '../../assets/cancer.png'
import leo from '../../assets/leo.png'
import virgo from '../../assets/virgo.png'
import libra from '../../assets/libra.png'
import scorpio from '../../assets/scorpio.png'
import sagittarius from '../../assets/sagittarius.png'
import capricorn from '../../assets/capricorn.png'
import aquarius from '../../assets/aquarius.png'
import pisces from '../../assets/pisces.png'

import countVisitors from '../../hooks/countVisitors'

const Zodiac = ({ setAssetsLoading, windowSize, details, setDetails, zodiacState, setZodiacState, setColorState }) => {
    // useEffect(() => {
    //     const zodiacCall = document.getElementById('zodiacCall')
    //     const pagesCall = document.getElementById('pagesCall')

    //     try {
    //         console.log('zodiac');
    //         zodiacCall.appendChild(pagesCall)
    //     } catch (error) {
    //         console.log(error);            
    //     }
    // }, [])

    const handleClick = ({zodiac}) => {
        EasySpeech.init()
        EasySpeech.detect()
        
        EasySpeech.speak({
            text: '          ',
            voice: EasySpeech.voices()[0],
            pitch: 1,
            rate: 1,
            boundary: event => console.debug('word boundary reached', event.charIndex),
            error: e => console.log(e),
        })  
        
        setDetails({...details, zodiac: zodiac})
        window.TiktokPixel(window, document, 'ttq');

        countVisitors({ page: 'spanish2-color' })

        setZodiacState(e => {return {...e, animation: false, events: false}})
        setColorState(e => {return {...e, display: true}})
        
        setTimeout(() => {
            setZodiacState(e => {return {...e, display: false}})
            setColorState(e => {return {...e, animation: true}})
        }, 500);

        setTimeout(() => {
            setColorState(e => {return {...e, events: true}})
        }, 1500);
    }
    
    return (
        <div className="zodiacMain" style={{ display: (zodiacState.display) ? 'flex' : 'none', zIndex: (zodiacState.display) ? 10 : 0, pointerEvents: (zodiacState.events) ? 'all' : 'none', opacity: (zodiacState.animation) ? 1 : 0 }} >
            {/* <div id='zodiacCall'></div> */}

            <p id='actionText'>Clickea En Tu Signo Para Comenzar</p>
            <p>¿Quieres descubrir lo que el destino te tiene reservado? Obtén tu horóscopo gratis con solo unos pocos clics y descubre lo que el futuro te depara!</p>

            <ul className="zodiacWheel" style={{ height: (zodiacState.animation) ? `${(windowSize.height > windowSize.width) ? (windowSize.width > 1000) ? 1000 : windowSize.width : (windowSize.height > 1000) ? 1000 : windowSize.height}px` : '10rem', width: (zodiacState.animation) ? `${(windowSize.height > windowSize.width) ? windowSize.width : windowSize.height}px` : '10rem', transform: (zodiacState.animation) ? 'rotate(360deg)' : 'rotate(0deg)' }}>
                <li className="zodiac">
                    <div className="zodiac-contents">
                        <img src={aries} alt="aries" style={{ transform: 'rotate(345deg)' }} onClick={() => handleClick({zodiac: 'Aries'})} onLoad={() => {setAssetsLoading(prev => {return {...prev, aries: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, aries: false}})}}/>
                        <p style={{ transform: 'translate(-50%, -50%) rotate(180deg)' }}>Aries</p>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents">
                        <img src={taurus} alt="taurus" style={{ transform: 'rotate(315deg)' }} onClick={() => handleClick({zodiac: 'Tauro'})} onLoad={() => {setAssetsLoading(prev => {return {...prev, taurus: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, taurus: false}})}}/>
                        <p style={{ transform: 'translate(-50%, -50%) rotate(180deg)' }}>Tauro</p>
                    </div>
                </li>
                <li className="zodiac" >
                    <div className="zodiac-contents">
                        <img src={gemini} alt="gemini" style={{ transform: 'rotate(285deg)' }} onClick={() => handleClick({zodiac: 'Geminis'})} onLoad={() => {setAssetsLoading(prev => {return {...prev, gemini: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, gemini: false}})}}/>
                        <p style={{ transform: 'translate(-50%, -50%) rotate(180deg)' }}>Geminis</p>
                    </div>
                        {/* <div id='zs' style={{ transform: 'rotate(285deg)' }}>
                            <img src={gemini} alt="gemini" onClick={(event) => handleClick({e: event, zodiac: 'Gemini'})} onMouseOver={() => setSelectedZodiac('Gemini')} onMouseLeave={() => setSelectedZodiac('')}/>
                            <div className="badge">
                                <div className='char char1'>G</div>
                                <div className='char char2'>E</div>
                                <div className='char char3'>M</div>
                                <div className='char char4'>I</div>
                                <div className='char char5'>N</div>
                                <div className='char char6'>I</div>
                            </div>
                        </div>
                        <p style={{ writingMode: 'vertical-lr', position: 'absolute', left: '50%', transform: 'translate(-50%, -50%) rotate(180deg)' }}>Gemini</p> */}
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents">
                        <img src={cancer} alt="cancer" style={{ transform: 'rotate(255deg)' }} onClick={() => handleClick({zodiac: 'Cáncer'})} onLoad={() => {setAssetsLoading(prev => {return {...prev, cancer: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, cancer: false}})}}/>
                        <p style={{ transform: 'translate(-50%, -50%) rotate(180deg)' }}>Cáncer</p>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents">
                        <img src={leo} alt="leo" style={{ transform: 'rotate(225deg)' }} onClick={() => handleClick({zodiac: 'Leo'})} onLoad={() => {setAssetsLoading(prev => {return {...prev, leo: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, leo: false}})}}/>
                        <p style={{ transform: 'translate(-50%, -50%) rotate(180deg)' }}>Leo</p>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents">
                        <img src={virgo} alt="virgo" style={{ transform: 'rotate(195deg)' }} onClick={() => handleClick({zodiac: 'Virgo'})} onLoad={() => {setAssetsLoading(prev => {return {...prev, virgo: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, virgo: false}})}}/>
                        <p style={{ transform: 'translate(-50%, -50%) rotate(180deg)' }}>Virgo</p>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents">
                        <img src={libra} alt="libra" style={{ transform: 'rotate(165deg)' }} onClick={() => handleClick({zodiac: 'Libra'})} onLoad={() => {setAssetsLoading(prev => {return {...prev, libra: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, libra: false}})}}/>
                        <p style={{ transform: 'translate(-50%, -50%)' }}>Libra</p>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents">
                        <img src={scorpio} alt="scorpio" style={{ transform: 'rotate(135deg)' }} onClick={() => handleClick({zodiac: 'Escorpión'})} onLoad={() => {setAssetsLoading(prev => {return {...prev, scorpio: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, scorpio: false}})}}/>
                        <p style={{ transform: 'translate(-50%, -50%)' }}>Escorpión</p>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents">
                        <img src={sagittarius} alt="sagittarius" style={{ transform: 'rotate(105deg)' }} onClick={() => handleClick({zodiac: 'Sagitario'})} onLoad={() => {setAssetsLoading(prev => {return {...prev, sagittarius: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, sagittarius: false}})}}/>
                        <p style={{ transform: 'translate(-50%, -50%)' }}>Sagitario</p>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents">
                        <img src={capricorn} alt="capricorn" style={{ transform: 'rotate(75deg)' }} onClick={() => handleClick({zodiac: 'Capricornio'})} onLoad={() => {setAssetsLoading(prev => {return {...prev, capricorn: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, capricorn: false}})}}/>
                        <p style={{ transform: 'translate(-50%, -50%)' }}>Capricornio</p>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents">
                        <img src={aquarius} alt="aquarius" style={{ transform: 'rotate(45deg)' }} onClick={() => handleClick({zodiac: 'Acuario'})} onLoad={() => {setAssetsLoading(prev => {return {...prev, aquarius: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, aquarius: false}})}}/>
                        <p style={{ transform: 'translate(-50%, -50%)' }}>Acuario</p>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents">
                        <img src={pisces} alt="pisces" style={{ transform: 'rotate(15deg)' }} onClick={() => handleClick({zodiac: 'Piscis'})} onLoad={() => {setAssetsLoading(prev => {return {...prev, pisces: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, pisces: false}})}}/>
                        <p style={{ transform: 'translate(-50%, -50%)' }}>Piscis</p>
                    </div>
                </li>
            </ul>

            <div>
                <p>¿Quieres descubrir lo que el destino te tiene reservado? Obtén tu horóscopo gratis con solo unos pocos clics y descubre lo que el futuro te depara!</p>
            </div>
        </div>
    )
}

export default Zodiac